<div class="container mx-auto py-6 min-h-screen">
  <h1
    class="text-2xl md:text-4xl font-semibold mb-4 md:ml-12 text-center md:text-left"
  >
    ОБЩИ УСЛОВИЯ за ползване на сайта na2kolela.bg
  </h1>
  <hr class="border-2 border-lightGreen mb-4 hidden md:block" />
  <div class="max-w-[90rem] px-4 md:px-2 mx-auto">
    <h3 class="font-semibold mb-2">1. Общи положения</h3>
    <div class="ml-4 space-y-4">
      <p>
        1.1. Настоящите общи условия (наричани по-долу “Общите условия”) уреждат
        отношенията между потребителите на сайта na2kolela.bg (наричан по-долу
        👍 “Сайтът”) и собствениците на Сайта – “Трейдит 24“ ООД.
      </p>

      <p>
        1.2. Чрез достъпване и използване на Сайта, Вие се съгласявате да
        спазвате тези Общи условия. Ако не сте съгласни с тях, не използвайте
        Сайта.
      </p>

      <p>
        1.3. Сайтът предоставя платформа за публикуване на обяви за продажба на
        велосипеди, скутери, тротинетки и части за тях от физически и юридически
        лица.
      </p>
    </div>

    <h3 class="font-semibold pt-2 mb-2">
      2. Регистрация и потребителски профил
    </h3>
    <div class="ml-4 space-y-4">
      <p>
        2.1. За да публикувате обяви на Сайта, е необходимо да се регистрирате и
        създадете потребителски профил.
      </p>

      <p>
        2.2. Потребителят е отговорен за всички действия, извършени чрез неговия
        профил.
      </p>

      <p>
        2.3. Потребителят трябва да предоставя точни и актуални данни при
        регистрацията и е длъжен да актуализира тези данни при нужда.
      </p>

      <p>
        2.4. Потребителят се задължава да не разкрива паролата си на трети лица
        и да уведомява незабавно администратора на Сайта при съмнение за
        неоторизиран достъп.
      </p>
    </div>

    <h3 class="font-semibold pt-2 mb-2">3. Правила за публикуване на обяви</h3>
    <div class="ml-4 space-y-4">
      <p>
        3.1. Потребителите могат да публикуват обяви за продукти и услуги, като
        при това се съгласяват да спазват следните правила:
      </p>
      <ul class="list-disc pl-6 space-y-1">
        <li>Обявите трябва да бъдат верни, точни и не заблуждаващи.</li>
        <li>
          Обявите трябва да бъдат само за обекти, отговарящи на предмета на
          дейност на сайта – велосипеди, скутери, тротинетки и части и аксесоари
          за тях.
        </li>
        <li>
          Забранено е публикуването на обяви, които нарушават законодателството
          или правата на трети лица (например, неоторизирана търговия с
          интелектуална собственост, незаконни стоки и услуги).
        </li>
        <li>
          Не се допуска публикуване на обяви с насилствено съдържание, расизъм,
          хомофобия или всякакви други форми на дискриминация.
        </li>
      </ul>

      <p>
        3.2. Сайтът има право да премахва обяви, които не отговарят на условията
        или са в нарушение на закона.
      </p>
      <p>
        3.3. Всяка обява може да бъде коригирана или изтрита. Корекцията на
        обявата не променя нейния статут. Статутът се променя само с корекция на
        самия статут. Корекцията на информация в обява или нейното изтриване се
        извършва незабавно (on-line).
      </p>

      <p>
        3.4. Всяка публикувана обява може да бъде докладвана за нередност от
        регистриран ползвател на услугите на Сайта. След проверка, Сайта има
        право да блокира обявата.
      </p>
    </div>

    <h3 class="font-semibold pt-2 mb-2">4. Права и задължения на Сайта</h3>
    <div class="ml-4 space-y-4">
      <p>
        4.1. Сайтът има право да редактира или премахва всяка обява, която не
        отговаря на стандартите за публикуване.
      </p>

      <p>
        4.2. Сайтът не носи отговорност за точността, законността или качеството
        на обявите, публикувани от потребителите.
      </p>

      <p>
        4.3. Сайтът си запазва правото да прекрати достъпа на потребители, които
        нарушават настоящите Общи условия.
      </p>
    </div>

    <h3 class="font-semibold pt-2 mb-2">5. Платени услуги</h3>
    <div class="ml-4 space-y-4">
      <p>
        5.1. Сайтът може да предлага платени услуги, като например “Промотиране
        на обяви”, “VIP обяви” и други.
      </p>
      <p>
        5.2. Платените услуги ще бъдат описани на Сайта и могат да бъдат
        активирани след извършване на съответно плащане.
      </p>
      <p>
        5.3. Потребителят се съгласява да заплати съответните такси за платените
        услуги, които се извършват чрез предоставените на Сайта методи за
        плащане.
      </p>
    </div>
    <h3 class="font-semibold pt-2 mb-2">6. Защита на лични данни</h3>
    <div class="ml-4 space-y-4">
      <p>
        6.1. Сайтът събира и обработва лични данни на потребителите съгласно
        политиката за защита на личните данни, която е част от тези Общи
        условия.
      </p>
      <p>
        6.2. Потребителят дава своето съгласие за обработка на лични данни при
        използване на услугите на Сайта.
      </p>
    </div>
    <h3 class="font-semibold pt-2 mb-2">7. Ограничение на отговорността</h3>
    <div class="ml-4 space-y-4">
      <p>
        7.1. Сайтът не носи отговорност за всякакви щети, които могат да
        възникнат в резултат на използването на Сайта или предоставените услуги.
      </p>
      <p>
        7.2. Сайтът не носи отговорност за никакви спорове между потребителите,
        които възникват в резултат на сделки, извършени чрез обявите.
      </p>
    </div>
    <h3 class="font-semibold pt-2 mb-2">8. Промени в общите условия</h3>
    <div class="ml-4 space-y-4">
      <p>
        8.1. Сайтът си запазва правото да променя настоящите Общи условия по
        всяко време, като промените ще бъдат публикувани на Сайта.
      </p>
      <p>
        8.2. Използването на Сайта след промяна на Общите условия се счита за
        приемане на новите условия.
      </p>
    </div>
    <h3 class="font-semibold pt-2 mb-2">9. Заключителни разпоредби</h3>
    <div class="ml-4 space-y-4">
      <p>
        9.1. За всички неуредени въпроси относно тези Общи условия се прилагат
        разпоредбите на българското законодателство.
      </p>
      <p>
        9.2. В случай на спорове, които не могат да бъдат разрешени
        извънсъдебно, те ще бъдат разглеждани от компетентния съд.
      </p>
      <p>
        9.3. Сайта си запазва правото да променя Общите условия по всяко време и
        по своя преценка. Промените се поместват на официалната страница на
        сайта и влизат в сила от деня на поместването им там. Ползвателите на
        услугите на сайта са длъжни да проверяват актуализациите на Общите
        условия и да съобразяват поведението си с тях.
      </p>
    </div>
    <h3 class="font-semibold pt-2 mb-2">10. Бисквитки</h3>
    <div class="ml-4 space-y-4">
      <p>
        10.1. “Бисквитките” (cookies) са малки файлове, които се съхраняват
        временно на вашия твърд (hard) диск и позволяват на сайта ни да
        разпознае компютъра ви следващия път, когато посетите Интернет
        страницата ни.
      </p>
      <p>
        10.2. Google Adwords ремаркетинг реклама. Този сайт използва ремаркетинг
        рекламна услуга на Google. Това означава, че когато посетите сайта,
        Google взима информация за посещението ви и след това изпраща наши
        реклами до нашите посетители в сайтовете които посещавате. Доставчици от
        трети страни включително Google използват “бисквитки” за да събират
        информацията за вашите посещения и я използват за да ви показват наши
        реклами в рекламните си площадки. Посетителите могат да се откажат от
        използването на „бисквитки“ от Google и доставчици от трети страни, на
        страницата за отказване на инициативата за мрежова реклама
        http://www.networkadvertising.org/choices/.
      </p>
    </div>
  </div>
</div>
